import { Component, OnInit } from '@angular/core';
import { LiferayService } from '../../../../../services/liferay/liferay.service';
import { LIFERAY_WEB_CONSTANT } from '../../../../../utils/liferay.constant';
import { IBannerMessages } from '../../../../../services/messages/messages.interface';
import { IWebContant } from '../../../../../services/liferay/liferay.interface';
import { DataService } from '../../../../../services/data/data.service';
import { trackByIndex } from '../../../../../utils/helper';

@Component({
  selector: 'app-weather-banner',
  templateUrl: './weather-banner.component.html',
  styleUrl: './weather-banner.component.scss'
})
export class WeatherBannerComponent implements OnInit {
  bannerMessages: IBannerMessages = { messages: [] };
  isBannerMessageVisible: boolean = false;
  isWeatherBannerVisible: boolean = true;
  trackByIndex = trackByIndex;
  constructor(
    private liferayService: LiferayService,
    private dataService:DataService) { }
  ngOnInit() {
    this.isBannerMessageVisible = this.dataService.isWeatherBannerVisible$.getValue();
    this.setBannerContent();
  }
  setBannerContent(): void {
    let content = LIFERAY_WEB_CONSTANT.banner_content;
    if(this.dataService.isWeatherBannerVisible$.getValue()) {
    this.liferayService.getWebContent<IBannerMessages>(content.type, content.id).subscribe({
      next: (data: IWebContant<IBannerMessages>) => {
        // Safely assign with fallback to ensure messages array always exists
        this.bannerMessages = data?.value && data.value.messages ? data.value : { messages: [] };
        this.isBannerMessageVisible = this.bannerMessages.messages && this.bannerMessages.messages.length > 0;
      }
    });
  }else{
    this.isBannerMessageVisible = false;
  }
  }


  handleMessageClose(): void {
       this.dataService.isWeatherBannerVisible$.next(false);
  }
}
